import { Outlet } from 'react-router-dom';
import Tracking from '../tracking';

export default function TrackedLayout() {
  return (
    <>
      <Tracking />
      <Outlet />
    </>
  );
}
